import { create } from '@/store'
import { devtools } from 'zustand/middleware'

export const useCustomerGroupsListStore = create(
  devtools(
    (set) => ({
      page: 1,
      pageSize: 10,
      setPage: (page) => set({ page }),
      setPageSize: (pageSize) => set({ pageSize }),
    }),
    {
      name: 'customer-groups-list-store',
    },
  ),
)
